module.exports = __webpack_public_path__ + "static/media/image_23.af9e7133.png";